export enum TicketOrigin {
  MyAddress,
  OtherAddress,
}
